import { Tooltip } from '@material-ui/core';
import React from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/images/info-svg.svg';

import { Theme, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
interface IInfoIconProps {
    infoMessage?: string;
    infoComponent?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: '#2D3A59',
        borderRadius: '10px',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
        width: '290px',
        height: 'auto',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        fontStyle: 'normal',
        fontWeight: 'normal',
        padding: '0.9375rem',
    },
}));

export function InfoIconToolTip({ infoMessage, infoComponent }: IInfoIconProps) {
    const classes = useStyles();
    const { t } = useTranslation();

    if (infoComponent) {
        return (
            <Tooltip interactive classes={classes} title={infoComponent}>
                <InfoIcon />
            </Tooltip>
        );
    }

    return infoMessage ? (
        <Tooltip classes={classes} title={t(infoMessage) as string}>
            <InfoIcon />
        </Tooltip>
    ) : null;
}
